// INF100 · porcentaje entero que no esconde filas.
// Redondeo normal, salvo en los extremos: nunca «100» si falta alguna fila
// (265 de 266 → 99) ni «0» si hay alguna (1 de 1000 → 1).

export function porcentajeSinEsconder(parte: number, total: number): number {
  if (!(total > 0) || !(parte > 0)) return 0;
  if (parte >= total) return 100;
  return Math.min(99, Math.max(1, Math.round((parte / total) * 100)));
}
